// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-audio {
  --color-theme: var(--black);
  --audio-height: 64px;
  --progress-height: 6px;
  --thumb-size: 14px;
  
  visibility: hidden;
  opacity: 0;
  transition: all .3s ease-out;
  transform: translateY(100%);

  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: var(--white);
  color: white;
  text-align: center;
  z-index: 100; /* Keep above most other things. */
  box-shadow: var(--shadow);
}

.c-audio.is-active {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  height: var(--audio-height);
}

.c-audio__inner {
  padding: 0 16px;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  gap: 8px;
}

.c-audio__listen {
  border-radius: 4px;
  border: 1px solid black;
  background: var(--white);
  padding: 8px 16px;
  color: var(--black);
  font-size: 14px;
}

.c-audio__listen-icon {
  fill: var(--black);
  height: 14px;
  width: 14px;
  margin-right: 4px;
}

.c-audio__play-btn {
  border: none;
  background: none;
  padding: 0;
}

.c-audio__play-icon {
  fill: var(--black);
}

.c-audio__icon {
  color: var(--black);
  height: 24px;
  width: 24px;
}

.c-audio__button {
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.c-audio__close {
  justify-self: end;
  align-self: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  height: var(--audio-height);
  width: var(--audio-height);
}

.c-audio__close-x {
  height: 24px;
  width: 24px;
  color: var(--black);
}

.c-audio__input[type="range"] {
  --range-progress: 0;

  /* Do not delete */
  -webkit-appearance: none;
  position: relative;
  background: rgb(1, 1, 1, 0.3);
  width: 100%;
  height: var(--progress-height);
  border-radius: 2px;
  cursor: pointer;
}

/* Input range - firefox */
.c-audio__input[type="range"]::-moz-range-track {
  position: relative;
  background:#ccc;
  width: 100%;
  height: var(--progress-height);
  border-radius: 2px;
  cursor: pointer;
}

/* played progress length - Chrome & safari*/
.c-audio__input[type="range"]::before {
  content: '';
  height: var(--progress-height);
  background: var(--color-theme);
  width: var(--range-progress);
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  position: absolute;
  top: 0;
  left: 0;
}

/* played progress length - firefox */
.c-audio__input[type="range"]::-moz-range-progress {
  background: var(--color-theme);
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  height: var(--progress-height);
}

/* slider thumb - chrome and safari */
.c-audio__input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: var(--thumb-size);
  width:  var(--thumb-size);
  border-radius: 50%;
  border: none;
  background-color: var(--color-theme);
  cursor: pointer;
  position: relative;
}

/* dragging thumb - chrome and safari */
.c-audio__input[type="range"]:active::-webkit-slider-thumb {
  transform: scale(1.2);
}

/* slider thumb - firefox */
.c-audio__input[type="range"]::-moz-range-thumb {
  height: var(--thumb-size);
  width:  var(--thumb-size);
  border-radius: 50%;
  background: var(--color-theme);
  cursor: pointer;
  border: transparent;
  position: relative;
}

/* dragging thumb - firefox */
.c-audio__input[type="range"]:active::-moz-range-thumb {
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/styles/audio.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;;EAElB,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,2BAA2B;;EAE3B,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,YAAY,EAAE,kCAAkC;EAChD,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;;EAEnB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB","sourcesContent":[".c-audio {\n  --color-theme: var(--black);\n  --audio-height: 64px;\n  --progress-height: 6px;\n  --thumb-size: 14px;\n  \n  visibility: hidden;\n  opacity: 0;\n  transition: all .3s ease-out;\n  transform: translateY(100%);\n\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: var(--white);\n  color: white;\n  text-align: center;\n  z-index: 100; /* Keep above most other things. */\n  box-shadow: var(--shadow);\n}\n\n.c-audio.is-active {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n  height: var(--audio-height);\n}\n\n.c-audio__inner {\n  padding: 0 16px;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 16px;\n  gap: 8px;\n}\n\n.c-audio__listen {\n  border-radius: 4px;\n  border: 1px solid black;\n  background: var(--white);\n  padding: 8px 16px;\n  color: var(--black);\n  font-size: 14px;\n}\n\n.c-audio__listen-icon {\n  fill: var(--black);\n  height: 14px;\n  width: 14px;\n  margin-right: 4px;\n}\n\n.c-audio__play-btn {\n  border: none;\n  background: none;\n  padding: 0;\n}\n\n.c-audio__play-icon {\n  fill: var(--black);\n}\n\n.c-audio__icon {\n  color: var(--black);\n  height: 24px;\n  width: 24px;\n}\n\n.c-audio__button {\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.c-audio__close {\n  justify-self: end;\n  align-self: center;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  height: var(--audio-height);\n  width: var(--audio-height);\n}\n\n.c-audio__close-x {\n  height: 24px;\n  width: 24px;\n  color: var(--black);\n}\n\n.c-audio__input[type=\"range\"] {\n  --range-progress: 0;\n\n  /* Do not delete */\n  -webkit-appearance: none;\n  position: relative;\n  background: rgb(1, 1, 1, 0.3);\n  width: 100%;\n  height: var(--progress-height);\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n/* Input range - firefox */\n.c-audio__input[type=\"range\"]::-moz-range-track {\n  position: relative;\n  background:#ccc;\n  width: 100%;\n  height: var(--progress-height);\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n/* played progress length - Chrome & safari*/\n.c-audio__input[type=\"range\"]::before {\n  content: '';\n  height: var(--progress-height);\n  background: var(--color-theme);\n  width: var(--range-progress);\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* played progress length - firefox */\n.c-audio__input[type=\"range\"]::-moz-range-progress {\n  background: var(--color-theme);\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  height: var(--progress-height);\n}\n\n/* slider thumb - chrome and safari */\n.c-audio__input[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  height: var(--thumb-size);\n  width:  var(--thumb-size);\n  border-radius: 50%;\n  border: none;\n  background-color: var(--color-theme);\n  cursor: pointer;\n  position: relative;\n}\n\n/* dragging thumb - chrome and safari */\n.c-audio__input[type=\"range\"]:active::-webkit-slider-thumb {\n  transform: scale(1.2);\n}\n\n/* slider thumb - firefox */\n.c-audio__input[type=\"range\"]::-moz-range-thumb {\n  height: var(--thumb-size);\n  width:  var(--thumb-size);\n  border-radius: 50%;\n  background: var(--color-theme);\n  cursor: pointer;\n  border: transparent;\n  position: relative;\n}\n\n/* dragging thumb - firefox */\n.c-audio__input[type=\"range\"]:active::-moz-range-thumb {\n  transform: scale(1.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
